const CustomTag = ({ text, icon, color, bgColor, onClick }) => {
    return <div style={{ color: color, backgroundColor: bgColor, borderRadius: 'var(--borderRadius)', display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.175rem 0.75rem', cursor: 'pointer' }} onClick={onClick}>
        {
            icon ? icon : <></>
        }
        <div className="textXS">{text}</div>
    </div>
}

export default CustomTag